import api from '../api';

const getMetadata = async (storeId) => {
  if (!storeId) {
    throw new Error('Store ID is required.');
  }

  const response = await api.get(`/wapi/store/metadata/${encodeURIComponent(storeId)}`);
  return response.data;
};

export default getMetadata;
